const fonts = {
  tiny: "0.5em",
  xSmall: "0.8em",
  small: "1em",
  smallMedium: "1.1em",
  mediumSmaller: "1.25em",
  medium: "1.3em",
  mediumBigger: "1.5em",
  mediumLarge: "1.6em",
  large: "2.1em",
  xLarge: "3em",
  huge: "4.2em",
};

export const fontWeights = {
  thin: 100,
  extraLight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  heavy: 900,
  extraHeavy: 950,
};

export default fonts;
